import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const CashifyPolicySubModalDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
        <Table>
            <tbody>
                {/* Policy Identification */}
                <tr>
                    <th>Document Number</th>
                    <td className="text-right pr-5">
                        {data.policy_no ? data.policy_no : '-'}
                    </td>
                </tr>
                <tr>
                    <th>Certificate Number</th>
                    <td className="text-right pr-5">
                        {data.certificate ? data.certificate : '-'}
                    </td>
                </tr>
                {/* Policy Lifecycle & Status */}
                <tr>
                    <th>Status</th>
                    <td className="text-right pr-5">
                        {data.status ? data.status : '-'}
                    </td>
                </tr>
                <tr>
                    <th>Start Date</th>
                    <td className="text-right pr-5">
                        {/* You might want to format this date */}
                        {data.start_date ? data.start_date : '-'}
                    </td>
                </tr>
                <tr>
                    <th>End Date</th>
                    <td className="text-right pr-5">
                         {/* You might want to format this date */}
                        {data.end_date ? data.end_date : '-'}
                    </td>
                </tr>
                 <tr>
                    <th>Payment Method</th>
                    <td className="text-right pr-5">
                        {data.payment_method ? data.payment_method : '-'}
                    </td>
                </tr>
                 {/* Conditionally show cancellation details if relevant */}
                 {data.status && data.status.toUpperCase().includes('CANCEL') && (
                    <>
                        <tr>
                            <th>Cancellation Reason</th>
                            <td className="text-right pr-5">
                                {data.cancellation_reason ? data.cancellation_reason : '-'}
                            </td>
                        </tr>
                         <tr>
                            <th>Cancellation Remarks</th>
                            <td className="text-right pr-5">
                                {data.cancellation_remarks ? data.cancellation_remarks : '-'}
                            </td>
                        </tr>
                    </>
                )}
                 <tr>
                    <th>Created On</th>
                    <td className="text-right pr-5">
                        {/* You might want to format this date/time */}
                        {data.created_at ? data.created_at : '-'}
                    </td>
                </tr>
                 <tr>
                    <th>Last Updated On</th>
                    <td className="text-right pr-5">
                        {/* You might want to format this date/time */}
                        {data.updated_at ? data.updated_at : '-'}
                    </td>
                </tr>
                {/* Optional: You might still want the internal Policy ID for reference */}
                {/* <tr>
                    <th>Policy ID</th>
                    <td className="text-right pr-5">
                        {data.policy_id ? data.policy_id : '-'}
                    </td>
                </tr> */}
                 {/* Optional: You might want to show who entered it */}
                 {/* <tr>
                    <th>Punched By</th>
                    <td className="text-right pr-5">
                        {data.punched_by ? data.punched_by : '-'}
                    </td>
                </tr> */}
    
            </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default CashifyPolicySubModalDetails;